import {
  useOnboardingFeatureEnabled,
  type OnboardingFeatureEnabledResult,
} from "../../onboarding/hooks/useOnboardingFeatureEnabled";
import { FeatureFlag } from "../../feature-flags";

export type ClientPayNormalisationEnabledResult =
  OnboardingFeatureEnabledResult;

/**
 * Composite gate for the client pay-run normalisation feature.
 *
 * The route is visible only when:
 *  1. `enable-onboarding` is on (parent `OnboardingLayout` also gates the subtree).
 *  2. `enable-client-pay-normalisation` is on.
 *
 * Access is flag-only — same posture as other onboarding import tools.
 */
export function useClientPayNormalisationEnabled(): ClientPayNormalisationEnabledResult {
  return useOnboardingFeatureEnabled(
    FeatureFlag.EnableClientPayNormalisation,
  );
}
